import { fromJS } from 'immutable'
import { createReducer } from 'redux-immutablejs'

import { SET_SESSION_ID } from './sessionActions'

interface SessionState extends Map<string, any> {
  sessionId: string | null
}

const initialState: SessionState = fromJS({
  sessionId: null,
})

export default createReducer(initialState, {
  [SET_SESSION_ID]: ($$state: SessionState, action: { value: string }) => {
    return $$state.set('sessionId', action.value)
  },
})
